import Vue from 'vue';
import router from '@/router/';
import store from '@/store';
import App from '@/App';
import '@/global/';
import { iconsSet as icons } from './assets/icons/icons.js'
import vuetify from './plugins/vuetify';
import ApioIcon from '@/components/Misc/Icon';
import ApioButton from '@/components/Misc/Button';
import ApioCheckbox from '@/components/Misc/Checkbox';
import ApioRadioButtons from '@/components/Misc/RadioButtons';
import ApioSnackbar from "@/components/Misc/Snackbar.vue";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { ContentLoader } from 'vue-content-loader'
import VueMq from 'vue-mq';
import PortalVue from 'portal-vue'
Vue.use(PortalVue);

Vue.use(VueMq, {
  breakpoints: {
    small: 376,
    medium: 769,
    large: 1024,
    xlarge: 1440,
    xxlarge: Infinity,
  }
});

Vue.component('ContentLoader', ContentLoader);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('apio-icon', ApioIcon);
Vue.component('apio-button', ApioButton);
Vue.component('apio-checkbox', ApioCheckbox);
Vue.component('apio-radio-buttons', ApioRadioButtons);
Vue.component('apio-snackbar', ApioSnackbar);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  vuetify,
  components: {
    App,
  }
});
